import { createContext, useContext } from 'react';

export const SCHOOL_REVIEW_MANUAL_PDF = '/docs/whatquiz-school-review-manual.pdf';

// 대메뉴(업무 탭) > 중메뉴(왼쪽 묶음) > 소메뉴. view 는 같은 화면 안에서 열 곳이다.
export const adminSections = (reviewId) => {
  const review = reviewId ? `/school-admin/review/${reviewId}` : null;
  return [
    {
      id: 'summary',
      label: '요약',
      home: '/school-admin',
      groups: [{ label: '요약', items: [{ id: 'home', label: '학교 현황', to: '/school-admin' }] }],
    },
    {
      id: 'review',
      label: '학생부 검토',
      home: review ? `${review}?view=status` : '/school-admin/review',
      groups: review
        ? [
          {
            label: '검토 진행',
            items: [
              { id: 'reviews', label: '검토 목록', to: '/school-admin/review' },
              { id: 'status', label: '검토 현황', to: `${review}?view=status` },
              { id: 'records', label: '기록 조회·검토', to: `${review}?view=records` },
              { id: 'same', label: '같은 문장 검토', to: `${review}?view=same` },
            ],
          },
          { label: '검토 마감·출력', items: [{ id: 'report', label: '차수 마감·검토 기록', to: `${review}?view=report` }] },
          {
            label: '관리',
            items: [
              { id: 'submit', label: '제출·마감 관리', to: `${review}?view=submit` },
              { id: 'files', label: '파일 관리', to: `${review}?view=files` },
            ],
          },
        ]
        : [{ label: '검토 진행', items: [{ id: 'reviews', label: '검토 목록', to: '/school-admin/review' }] }],
    },
    {
      id: 'school',
      label: '학교 관리',
      home: '/school-admin?view=members',
      groups: [{
        label: '학교 관리',
        items: [
          { id: 'members', label: '교원 관리', to: '/school-admin?view=members' },
          { id: 'usage', label: '사용 현황', to: '/school-admin?view=usage' },
        ],
      }],
    },
    {
      id: 'help',
      label: '도움말',
      home: '/school-admin/help/criteria',
      groups: [{
        label: '도움말',
        items: [
          { id: 'manual', label: '사용 설명서', href: SCHOOL_REVIEW_MANUAL_PDF },
          { id: 'criteria', label: '검토 기준 안내', to: '/school-admin/help/criteria' },
          { id: 'terms', label: '나이스 용어 대응', to: '/school-admin/help/terms' },
        ],
      }],
    },
  ];
};

// 주소로 지금 업무 탭과 소메뉴를 정한다.
export const activeMenu = (pathname, search) => {
  const view = new URLSearchParams(search).get('view') || '';
  const review = pathname.match(/^\/school-admin\/review\/([^/?#]+)/);
  if (review) return { section: 'review', item: view || 'status', reviewId: review[1] };
  if (pathname.startsWith('/school-admin/review')) return { section: 'review', item: 'reviews', reviewId: null };
  const help = pathname.match(/^\/school-admin\/help\/([a-z]+)/);
  if (help) return { section: 'help', item: help[1], reviewId: null };
  if (view === 'members' || view === 'usage') return { section: 'school', item: view, reviewId: null };
  return { section: 'summary', item: 'home', reviewId: null };
};

// 셸 밖(테스트·단독 화면)에서는 null 이라 화면이 예전처럼 동작한다.
export const AdminShellContext = createContext(null);
export const useAdminShell = () => useContext(AdminShellContext);
